export default [
    {
        path: 'setor',
        component: () => import(
            /* webpackChunkName: 'cadastro-setor' */
            '@/views/cadastro/setor/Index'
        ),
        redirect: 'setor/index',
        children: [
            {
                name: 'cadastro-setor-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-setor' */
                    '@/views/cadastro/setor/List.vue'
                ),
            },
            {
                name: 'cadastro-setor-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-setor' */
                    '@/views/cadastro/setor/Form.vue'
                ),
            },
            {
                name: 'cadastro-setor-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-setor' */
                    '@/views/cadastro/setor/Form.vue'
                ),
            },
        ],
    },
]